import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const InputInfo = styled.div`
  position: inherit;
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: ${(props) => props.theme.colors.inputInfoMessage};
`;

const InputInfoMessage = ({ message }) => {
  if (message) {
    return <InputInfo>{message}</InputInfo>;
  }

  return null;
};

InputInfoMessage.propTypes = {
  active: PropTypes.bool,
  showWhenNotActive: PropTypes.bool,
};
InputInfoMessage.defaultProps = {
  active: true,
  showWhenNotActive: true,
};

export default InputInfoMessage;
